import axios from 'axios';
import { camelizeKeys } from 'humps';
import { getEndpoint } from './api';

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.message === 'Network Error') {
      const networkErr = new Error('Network Error');
      networkErr.isNetworkError = true;
      return Promise.reject(networkErr);
    }
    return Promise.reject(error);
  },
);

export const makeRequest = async ({
  method = 'POST',
  apiUrl,
  userId,
  currentSession,
  route,
  data,
  params = {},
  headers = {},
}) => {
  const url = getEndpoint(apiUrl)[route];
  const jwt = currentSession;

  return axios({
    method,
    url,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${jwt}`,
      'x-cognito-id': userId,
      ...headers,
    },
    data,
    params,
  })
    .then((success) => {
      return camelizeKeys(success.data);
    })
    .catch((error) => {
      if (error.isNetworkError) {
        const networkErr = new Error('Network Error');
        networkErr.isNetworkError = true;
        throw networkErr;
      }
      const status = error?.response?.status || error?.status;
      if (status === 401) {
        const authErr = new Error('Unauthorized');
        authErr.status = 401;
        throw authErr;
      }
      if (Math.floor(status / 100) === 5) {
        const serverErr = new Error('Server Error');
        serverErr.code = 500;
        throw serverErr;
      }
      const respData = error?.response?.data;
      if (respData?.code === 'noContest') return respData;
      throw respData || error;
    });
};
